import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import { fonts } from 'constants/cssConstants'

const DivContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`

const DivKeyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  span {
    font-size: 14px;
    font-weight: bold;
    font-family: ${fonts.sans};
  }
`
/**
 * Obly for dev activity
 */
const EnvViewer = () => {
  const keys = Object.keys(process.env)
  const values = Object.values(process.env)

  const getEnvItem = (item: string | undefined) => {
    return item && typeof item !== 'object' ? `${item}` : '-'
  }

  return (
    <div>
      Env keys and values
      <DivContainer>
        <div>
          <span>Keys</span>
          <DivKeyWrapper>
            {keys.map((item) => {
              return (
                <div key={`${item}-${uuidv4()}`}>
                  <span>{getEnvItem(item)}</span>
                </div>
              )
            })}
          </DivKeyWrapper>
        </div>
        <div>
          <span>Values</span>
          <DivKeyWrapper>
            {values.map((item) => {
              return (
                <div key={`${item}-${uuidv4()}`}>
                  <span>{getEnvItem(item)}</span>
                </div>
              )
            })}
          </DivKeyWrapper>
        </div>
      </DivContainer>
    </div>
  )
}

export default EnvViewer
